import { CALL_API } from "redux-api-middleware"
import { get, post, put } from "utils/network"

export const fetchClassList = () => (dispatch, getState) => {
  if (getState().grade.get("classHasFetched")) {
    return Promise.resolve()
  }
  const request = get("/grades/classes")
  request.types = ["GRADE_REQ", "GRADECL_GET_SUCC", "NOTIF_FAIL"]
  return dispatch({ [CALL_API]: request })
}

export const fetchClass = offeringGroupID => (dispatch, getState) => {
  if (getState().grade.getIn(["cache", offeringGroupID])) {
    return Promise.resolve()
  }
  const request = get(`/grades/${offeringGroupID}`)
  request.types = [
    "GRADE_REQ",
    {
      type: "GRADE_GETONE_SUCC",
      meta: { offeringGroupID },
    },
    "NOTIF_FAIL",
  ]
  return dispatch({ [CALL_API]: request })
}

export const saveCache = (offeringGroupID, data) => {
  return {
    type: "GRADE_CACHE_SUCC",
    meta: { offeringGroupID, data },
  }
}

export const saveGrades = (offeringGroupID, students) => {
  const request = post("/grades/" + offeringGroupID, students)
  request.types = ["GRADE_REQ", "NOTIF_SUCC", "NOTIF_FAIL"]
  return { [CALL_API]: request }
}

export const submitGrades = (offeringGroupID, students) => {
  const request = post(`/grades/${offeringGroupID}/submit`, students)
  request.types = ["GRADE_REQ", "NOTIF_SUCC", "NOTIF_FAIL"]
  return { [CALL_API]: request }
}

// "/grades/:offeringGroupID/:semcampSubjEnrolledID/request-unlock"
export const requestUnlock = (offeringGroupID, scSubjectEnrolledID) => {
  const request = put(
    `/grades/${offeringGroupID}/${scSubjectEnrolledID}/request-unlock`
  )
  request.types = [
    "GRADE_R_REQ",
    {
      type: "GRADE_GETONE_SUCC",
      meta: { offeringGroupID },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}

// "/grades/:offeringGroupID/:semcampSubjEnrolledID/cancel-request-unlock"
export const requestCancelUnlock = (offeringGroupID, scSubjectEnrolledID) => {
  const request = put(
    `/grades/${offeringGroupID}/${scSubjectEnrolledID}/request-unlock-cancel`
  )
  request.types = [
    "GRADE_R_REQ",
    {
      type: "GRADE_GETONE_SUCC",
      meta: { offeringGroupID },
    },
    "NOTIF_FAIL",
  ]
  return { [CALL_API]: request }
}



// WEBPACK FOOTER //
// ./src/containers/Grades/actions.js